export const FEED_RADII = [
  { label: 'Nearby', km: 2 },
  ...[5, 10, 20, 100, 500, 1000].map((km) => ({ label: `${km} KM`, km })),
  { label: 'Global', km: null },
];

export const DISCUSSION_TYPES = ['area-discussion', 'artist-work'];
const EARTH_RADIUS_KM = 6371.0088;

export function hasCoordinates(location) {
  return Number.isFinite(location?.lat) && Math.abs(location.lat) <= 90
    && Number.isFinite(location?.lng) && Math.abs(location.lng) <= 180;
}

export function distanceKm(from, to) {
  if (!hasCoordinates(from) || !hasCoordinates(to)) return null;
  const radians = (degrees) => degrees * Math.PI / 180;
  const lat = radians(to.lat - from.lat);
  const lng = radians(to.lng - from.lng);
  const a = Math.sin(lat / 2) ** 2 + Math.cos(radians(from.lat)) * Math.cos(radians(to.lat)) * Math.sin(lng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(Math.min(1, Math.max(0, a))));
}

export function latitudeBounds(center, radiusKm) {
  if (!hasCoordinates(center) || !Number.isFinite(radiusKm) || radiusKm <= 0) throw new Error('Choose a valid location and radius.');
  const delta = radiusKm / EARTH_RADIUS_KM * 180 / Math.PI;
  return { min: Math.max(-90, center.lat - delta), max: Math.min(90, center.lat + delta) };
}

export function withinRadius(post, center, radiusKm) {
  if (radiusKm === null) return true;
  const distance = distanceKm(center, post);
  return distance !== null && distance <= radiusKm;
}
